// Styles
import '../assets/sass/web/_gruhapravesh.scss';
import LeadForm from './gruhapravesh/components/lead-form.component';

$(window).on('load', function () {

    const forms = document['lead-form'];

    if(forms.constructor.name === 'HTMLCollection') {
        for(let i=0; i<forms.length; i++) {
            new LeadForm(forms[i]);
        }
    } else {
        new LeadForm(forms);
    }
});